import React from "react";
import { motion } from "framer-motion";
import ctaLeft from '../Images/cta-left.svg'
import ctaRight from '../Images/cta-right.svg'

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: "easeOut",
    },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.2,
    },
  },
};

const Cta = ({heading, desc}) => {
  return (
    <section className="cta-section">
                <img
    src={ctaLeft}
    alt="Begin Your Healing Journey Today | Dr. Jigar Gor's Ayurveda"
    className="cta-design cta-design-left"
  />


  <img
    src={ctaRight}
    alt=" Begin Your Healing Journey Today | Dr. Jigar Gor's Ayurveda"
    className="cta-design cta-design-right"
  />
      <div className="container">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.3,
          }}
        >
          <motion.p
            className="section-subheading"
            variants={fadeUp}
          >
            Your Wellness, Our Commitment.
          </motion.p>

          <motion.h2
            className="section-heading"
            variants={fadeUp}
          >
            { heading || "Begin Your Healing Journey Today" }
          </motion.h2>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            { desc || "Experience the power of authentic Ayurveda through personalized consultations, holistic therapies, and time-tested healing practices designed to restore balance, improve overall well-being, and naturally transform your health from within. Our expert-guided treatments focus on identifying the root cause and helping you achieve long-lasting physical, mental, and emotional wellness." }
          </motion.p>

          <div className="cta-btns">
           <motion.a
              href="/book-appointment?mode=online#appointment-form"
            className="nav-btn"
            variants={fadeUp}
            whileHover={{
              scale: 1.03,
              y: -2,
            }}
            whileTap={{
              scale: 0.98,
            }}
            transition={{
              duration: 0.4,
            }}
          >
            Book Online Consulation
          </motion.a>
          <motion.a
            href="/prakruti-analysis"
            className="primary-btn"
            variants={fadeUp}
            whileHover={{
              scale: 1.03,
              y: -2,
            }}
            whileTap={{
              scale: 0.98,
            }}
            transition={{
              duration: 0.4,
            }}
          >
           Prakruti Analysis
          </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Cta;